import { formatHotkeyLabel } from '@/lib/hotkeys/formatHotkeyLabel';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import type { HotkeyId } from '@/lib/hotkeys/registry';

/**
 * Resolve the live binding + display label for a configurable hotkey.
 * Useful for tooltips / sidebar hints that should reflect user overrides.
 */
export function useHotkeyLabel(id: HotkeyId): {
  keys: string;
  label: string;
} {
  const { getKeys } = useKeyboardShortcuts();
  const keys = getKeys(id);
  return {
    keys,
    label: formatHotkeyLabel(keys),
  };
}
